var PaginationControls = require("components/utility/PaginationControls");
var WarmupQuestionsDisplay = require("components/writing/quizzes/warmups/WarmupQuestionsDisplay");
var BookDisplay = require("components/reading/books/BookDisplay")
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

require("appdev/warmup_question_display_page.scss")

class WarmupQuestionDisplayPage extends React.Component {

	constructor(props) {
		super();
		autobind(this);

		this.state = {
			warmupDataInput: "", warmupData: null, page: 1
		}
	}

	changePage(newPage) {
		this.setState({ page: newPage });
	}

	onClick(e) {
		$wr.nope(e)

		try {
			var warmupData = JSON.parse(this.state.warmupDataInput);
			this.setState({ warmupData: warmupData });

		} catch(error) {
			alert("JSON parse error!");
		}
	}

	render() {

		if (this.state.warmupData) {
			var perPage = 100;
			var pagination = (
				<PaginationControls page={ this.state.page } perPage={ perPage }
					totalCount={ this.state.warmupData.length } onChange={ this.changePage } />
			);

			var pageStart = this.state.page * perPage;
			var warmups = this.state.warmupData.slice(pageStart, pageStart + perPage);


			var warmupDisplays = _.map(warmups, (warmup, index) => {
				var answers = { [warmup.key]: warmup.content };
				if (!answers[TopicQuestion.STEM]) {
					var answers = _.extend({}, answers, {
						[TopicQuestion.STEM]: {
							[TopicQuestion.TEXT_TYPE]: "TEXT",
							[TopicQuestion.MAIN_ENTITY]: "ENTITY",
							[TopicQuestion.MAIN_TOPICS]: "TOPIC"
						}
					})
				}
				return (
					<div className="warmupBox" key={ pageStart + index }>
						<div className="warmupHeader">
							<BookDisplay textID={ warmup.text_id } />{" "}
							<strong>{ warmup.key }, { warmup.level }</strong>
						</div>
						<WarmupQuestionsDisplay displayOnly
							level={ warmup.level } displayOnlyKey={ warmup.key }
							initAnswers={ answers } />
					</div>
				);
			});

			var warmupContent = (
				<div>
					{ pagination }
					<div>
						{ warmupDisplays }
					</div>
					{ pagination }
				</div>
			);			
		}

		return (
			<div className="warmupQuestionDisplayPage container">

				<div className="controlSection hideOnPrint">
					<div className="headerSection">
						<header className="pageHeader">
							<h1>Warmup Question Display Page</h1>
						</header>
					</div>

					<textarea className="warmupData form-control"
						value={ this.state.warmupDataInput }
						onChange={ (e) => { this.setState({ warmupDataInput: e.target.value }) } } />
					<div className="text-right">
						<a href="#" onClick={ this.onClick }>Load</a>
					</div>
					{ warmupContent }
				</div>
			</div>
		)
	}

};

WarmupQuestionDisplayPage.propTypes = PageStrictPropTypes({
});

module.exports = WarmupQuestionDisplayPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/WarmupQuestionDisplayPage.js